const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const d = new Date();

export const month = monthNames[d.getMonth()];
export const time_or_date = d.getDate();
export const beginning_of_month = (d.getMonth() + 1);